const ROLE_LABELS = {
  STUDENT: "Student",
  MEMBER: "Student",
  INSTRUCTOR: "Instructor",
  COURSE_COORDINATOR: "Coordinator",
  ADMIN: "Admin",
  GLOBAL_ADMIN: "Global Admin",
  AGENCY_ADMIN: "Agency Admin",
};

/** Human label for a platform role code. Unknown codes are shown as they are. */
export function roleLabelFor(role) {
  return ROLE_LABELS[String(role).toUpperCase()] || role;
}

/** Programme colour and label for a training center. */
export function programStyle(program) {
  if (program === "firefighter") return { label: "Firefighter", color: "var(--color-cat-firefighter)", bg: "rgba(194,65,12,.10)" };
  if (program === "emt") return { label: "EMS", color: "var(--color-cat-ems)", bg: "rgba(37,99,235,.10)" };
  return { label: "General", color: "var(--color-cat-other)", bg: "rgba(180,83,9,.10)" };
}

export const fmtNumber = (n) => (n ?? 0).toLocaleString();

export function initialsOf(name) {
  return (name || "").split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();
}

/** Recently opened training centers, kept per browser. Storage can be blocked, so every access is guarded. */
const RECENT_KEY = "ga-recent-centers";

export function readRecentCenterIds() {
  try {
    const parsed = JSON.parse(localStorage.getItem(RECENT_KEY) || "[]");
    return Array.isArray(parsed) ? parsed.map(String).slice(0, 3) : [];
  } catch {
    return [];
  }
}

export function rememberRecentCenter(id) {
  try {
    const next = [String(id), ...readRecentCenterIds().filter((x) => x !== String(id))].slice(0, 3);
    localStorage.setItem(RECENT_KEY, JSON.stringify(next));
  } catch {
    // Storage unavailable: the list just won't remember this visit.
  }
}
